import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectAdmin(data) {
  return request({
    url: `/administrator/selectUser`,
    method: "POST",
    data,
  });
}

/**
 * 新增
 * @param {*} data
 * @returns
 */
export function addAdmin(data) {
  return request({
    url: `/administrator/add`,
    method: "POST",
    data,
  });
}

/**
 * 手动新增账号
 * @param {*} data
 * @returns
 */
export function addAdminManual(data) {
  return request({
    url: `/administrator/addAdmin`,
    method: "POST",
    data,
  });
}

/**
 * 更改用户信息
 * @param {*} data
 * @returns
 */
export function updateAdmin(data) {
  return request({
    url: `/administrator/updateUser`,
    method: "POST",
    data,
  });
}

/**
 * 更改密码
 * @param {*} data - { username, oldPassword, newPassword }
 * @returns
 */
export function updatePassword(data) {
  return request({
    url: `/sys/user/updatePassword`,
    method: "PUT",
    data: {
      username: data.username,
      oldPassword: data.oldPassword,
      newPassword: data.newPassword
    },
  });
}

/**
 * 为当前用户分配 PF 账号（测试接口）
 * @param {*} params - { tenantId, userId, operator }
 * @returns
 */
export function allocatePfUsername(params) {
  return request({
    url: `/dev/test/allocatePf`,
    method: "GET",
    params,
  });
}

/**
 * 模拟完整医生同步流程（后端写死 dataList/dataType/clientId）
 * @returns
 */
export function processDoctorsMock() {
  return request({
    url: `/dev/test/processDoctorsMock`,
    method: "GET",
  });
}


/**
 * 编辑权限
 * @param {*} data
 * -role_id
 * @returns
 */
export function updateRole(data) {
  return request({
    url: `/administrator/updateRole`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data
 * @returns
 */
export function deleteAdmin(data) {
  return request({
    url: `/administrator/delete`,
    method: "POST",
    data,
  });
}


/**
 * 查询角色
 * @param {*} data
 * @returns
 */
export function selectAuthGroup(data) {
  return request({
    url: `/administrator/selectAuthGroupList`,
    method: "POST",
    data,
  });
}

